import React, { Component } from 'react';
import {selectHomeInfo} from "../../../selectors";
import { getMyAutoPayInfo, enableAutoPayACH, enableAutoPayCC, disableAutoPay, getAutoPayAvailableCC } from "../../../actions/homeInfoActions";
import { connect } from "react-redux";
import { Form, Formik, Field } from "formik";
import {toastr} from "react-redux-toastr";
import Loader from "react-spinners/BeatLoader";
import isEmpty from "../../../utils/helpers";
import {object, string} from "yup";

const ACCOUNT_TYPE = {
    CHECKING: 'CHECKING',
    SAVINGS: 'SAVINGS',
    BUSINESS_CHECK: 'BUSINESS_CHECK'
}

const ccSchema = object().shape({
    cc: object().required('Required')
});

const achSchema = object().shape({
    routingNumber: string().required('Required'),
    accountNumber: string().required('Required'),
    cardHolderName: string().required('Required'),
    accountType: string().required('Required')
});

export class AutoPay extends Component {
    
    state = {
        myAutoPayInfoLoading: false,
        autopayUpdated: false,
        autopayActive: !isEmpty(this.props.myAutoPayInfo),
        ccActive: (this.props.myAutoPayInfo && this.props.myAutoPayInfo.apiAccountAutoPayCC) || false,
        achActive: (this.props.myAutoPayInfo && this.props.myAutoPayInfo.apiAccountAutoPayACH) || false,
    }

    handleEnableAutoPay = (props) => {
        if (this.props.myAutoPayInfo && Object.keys(this.props.myAutoPayInfo).length !== 0) {

            toastr.confirm("Are you sure you want to disable AutoPay?", {
                cancelText: "Cancel",
                okText: "Confirm",
                onOk: () => {
                    this.setState({myAutoPayInfoLoading: 'enable'});

                    this.props.disableAutoPay(props.values).then(response => {
                        this.setState({
                            autopayUpdated: false,
                            myAutoPayInfoLoading: false,
                            autopayActive: false,
                            ccActive: false,
                            achActive: false
                        });
                    });
                },
                onCancel: () => {
                }
            });
        }
        else {
            this.setState((prevState) => ({
                autopayActive: !prevState.autopayActive,
                ccActive: prevState.autopayActive === true ? false : true,
                achActive: false
            }));
        }
    }

    handleCCSubmit = (values) => {
        this.setState({myAutoPayInfoLoading: 'card'});

        this.props.enableAutoPayCC(values).then(response => {
            this.setState({autopayUpdated: true, myAutoPayInfoLoading: 'info'}, () => {

                this.props.getMyAutoPayInfo(this.props.accountInfo.id).then(response => {
                    this.setState({myAutoPayInfoLoading: false});
                });
            });
        });
    }

    handleACHSubmit = (values) => {
        this.setState({myAutoPayInfoLoading: 'ach'});

        this.props.enableAutoPayACH(values).then(response => {
            this.setState({autopayUpdated: true, myAutoPayInfoLoading: 'info'}, () => {

                this.props.getMyAutoPayInfo(this.props.accountInfo.id).then(response => {
                    this.setState({myAutoPayInfoLoading: false});
                });
            });
        });
    }

    render() {
        const {
            autopayActive,
            myAutoPayInfoLoading,
            autopayUpdated,
            achActive,
            ccActive
        } = this.state;

        const {
            accountInfo,
            myAutoPayInfo,
            myAutoPayAvailableCC,
        } = this.props;

        return (
            <div className="cp-form cp-form-autopay">

                <div className="form-section">
                    <h4>AutoPay</h4>
                    <p className="form-divider">
                        {myAutoPayInfoLoading
                            ? <span>&nbsp;</span>
                            : myAutoPayInfo && myAutoPayInfo && Object.keys(myAutoPayInfo).length !== 0
                                ? "Active. AutoPay applies on " + myAutoPayInfo.appliesOn
                                : "AutoPay is Inactive."
                        }
                    </p>
                </div>

                <div className="form-group">
                    <Formik
                        initialValues={{
                            accountId: accountInfo.id
                        }}
                        onSubmit={this.handleSubmit}
                    >
                        {props => (
                            <Form>
                                <div className="custom-switch-with-button">
                                    <div className="custom-control custom-switch">
                                        <input
                                            className="custom-control-input"
                                            disabled={myAutoPayInfoLoading ? 'disabled' : false}
                                            checked={autopayActive}
                                            name="autopayActive"
                                            id="autopayActive"
                                            type="checkbox"
                                            onClick={() => this.handleEnableAutoPay(props)}
                                        />
                                        <label className="custom-control-label custom-control-label-opaque d-block" htmlFor="autopayActive">
                                            Enable AutoPay
                                            {myAutoPayInfoLoading === 'enable' && <Loader css={'float: right'} size={5} color={'#258C9F'}/>}
                                        </label>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>

                {autopayActive &&
                <hr/>
                }

                {autopayActive &&
                <div className="form-group">
                    <div className="custom-switch-with-button">
                        <div className="custom-control custom-switch">
                            <input
                                className="custom-control-input"
                                disabled={myAutoPayInfoLoading || ccActive ? 'disabled' : false}
                                value={ccActive}
                                checked={ccActive}
                                name="card"
                                id="card"
                                type="checkbox"
                                onChange={(event) => {
                                    this.setState({ccActive: event.target.checked});

                                    if (event.target.checked === true) {
                                        this.setState({
                                            autopayActive: true,
                                            achActive: false,
                                            autopayUpdated: false
                                        });
                                    }
                                }}
                            />
                            <label className="custom-control-label custom-control-label-opaque d-block" htmlFor="card">
                                Debit / Credit Card
                                {myAutoPayInfoLoading === 'card' &&
                                <Loader css={'float: right'} size={5} color={'#258C9F'}/>}
                                <p className="text-muted text-xs mb-0">
                                    {isEmpty(myAutoPayAvailableCC)
                                    ? "Please make a payment to enable AutoPay."
                                    : "Choose from existing debit / credit cards."
                                    }
                                </p>
                            </label>
                        </div>
                    </div>
                </div>
                }

                {ccActive && !isEmpty(myAutoPayAvailableCC) &&
                <div className="form-group">
                    <Formik
                        initialValues={{
                            accountId: accountInfo.id,
                            cc: '',
                            type: '',
                            cardToken: '',
                            cardExpirationDate: '',
                            displayCardNumber: ''
                        }}
                        validationSchema={ccSchema}
                        validateOnChange={true}
                        onSubmit={(values) => {
                            this.handleCCSubmit(values);
                        }}
                        render={(props) => {
                            const {values, touched, errors, setFieldValue} = props;

                            return (
                                <Form className="mb-5">
                                    <div className="cp-table-primary form-group">
                                        <div className="row-expand">
                                            <div>
                                                <div className="cp-datarow-container mr-3 ml-3">
                                                    <div className="cp-datarow-wrapper">

                                                        {myAutoPayInfoLoading === 'info' && <Loader size={5} color={'#258C9F'}/>}

                                                        {myAutoPayInfo && myAutoPayInfo.apiAccountAutoPayCC && myAutoPayInfo.apiAccountAutoPayCC.displayCardNumber && <>
                                                        <div className="order-label">Details</div>
                                                        <div className="cp-datarow-row">
                                                            <div className="cp-datarow-label">Current Card</div>
                                                            <div className="cp-datarow-value">{myAutoPayInfo.apiAccountAutoPayCC.displayCardNumber}</div>
                                                        </div>
                                                        </> }

                                                        {(!autopayUpdated || (myAutoPayInfo && !myAutoPayInfo.apiAccountAutoPayCC)) && <>
                                                        <div className="order-label">New Card</div>

                                                        <div className="form-group">
                                                            <select
                                                                id="cc"
                                                                name="cc"
                                                                className={"form-control form-control-sm" + (touched.cc && errors.cc ? " is-invalid" : "")}
                                                                disabled={myAutoPayInfoLoading && 'disabled'}
                                                                onChange={(e) => {
                                                                    setFieldValue('cc', myAutoPayAvailableCC[parseInt(e.target.value)]);
                                                                    setFieldValue('type', myAutoPayAvailableCC[parseInt(e.target.value)].type);
                                                                    setFieldValue('cardToken', myAutoPayAvailableCC[parseInt(e.target.value)].cardToken)
                                                                    setFieldValue('cardExpirationDate', myAutoPayAvailableCC[parseInt(e.target.value)].cardExpirationDate);
                                                                    setFieldValue('displayCardNumber', myAutoPayAvailableCC[parseInt(e.target.value)].displayCardNumber);
                                                                }}
                                                            >
                                                                <option selected disabled>Select card...</option>
                                                                {myAutoPayAvailableCC.map((cc, index) =>
                                                                    <option value={index}>{cc.displayCardNumber}</option>
                                                                )};
                                                            </select>
                                                            {touched.cc && errors.cc &&
                                                                <div className="invalid-feedback">{errors.cc}</div>
                                                            }
                                                        </div>
                                                        </> }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {(!autopayUpdated || (myAutoPayInfo && !myAutoPayInfo.apiAccountAutoPayCC)) &&
                                    <div className="form-group text-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={myAutoPayInfoLoading && 'disabled'}
                                        >
                                            Save Changes
                                        </button>
                                    </div>
                                    }

                                </Form>
                            )
                        }}
                    />
                </div>
                }

                {ccActive && isEmpty(myAutoPayAvailableCC) &&

                    <div className="form-group text-right">
                        <button
                            className="btn btn-primary"
                            onClick={() => {

                                // Close AutoPay Panel
                                this.props.togglePanel(4)

                                // Wait for animation to finish
                                setTimeout(() => {

                                    // Open Payment Panel
                                    this.props.togglePanel(3)
                                }, 300)
                            }}
                        >
                            Make a Payment
                        </button>
                    </div>
                }

                {autopayActive &&
                <div className="form-group">
                    <div className="custom-switch-with-button">
                        <div className="custom-control custom-switch">
                            <input
                                className="custom-control-input"
                                disabled={myAutoPayInfoLoading || achActive ? 'disabled' : false}
                                value={achActive}
                                checked={achActive}
                                name="ach"
                                id="ach"
                                type="checkbox"
                                onChange={(event) => {
                                    this.setState({achActive: event.target.checked});

                                    if (event.target.checked === true) {
                                        this.setState({
                                            autopayActive: true,
                                            ccActive: false,
                                            autopayUpdated: false
                                        });
                                    }
                                }}
                            />
                            <label className="custom-control-label custom-control-label-opaque d-block" htmlFor="ach">
                                New Checking / Saving Account
                                {myAutoPayInfoLoading === 'ach' &&
                                <Loader css={'float: right'} size={5} color={'#258C9F'}/>}
                                <p className="text-muted text-xs mb-0">Add new checking / saving account to use.</p>
                            </label>
                        </div>
                    </div>
                </div>
                }

                {achActive &&
                <div className="form-group">
                    <Formik
                        initialValues={{
                            routingNumber: '',
                            accountNumber: '',
                            accountId: accountInfo.id,
                            cardHolderName: '',
                            accountType: ''
                        }}
                        validationSchema={achSchema}
                        onSubmit={(values) => {
                            this.handleACHSubmit(values);
                        }}
                        render={(props) => {
                            const {values, touched, errors, setFieldValue} = props;

                            return (
                                <Form className="mb-5">
                                    <div className="cp-table-primary form-group">
                                        <div className="row-expand">
                                            <div>
                                                <div className="cp-datarow-container mr-3 ml-3">
                                                    <div className="cp-datarow-wrapper">

                                                        {myAutoPayInfoLoading === 'info' && <Loader size={5} color={'#258C9F'}/>}

                                                        {myAutoPayInfo && myAutoPayInfo.apiAccountAutoPayACH && <>
                                                        <div className="order-label">Details</div>
                                                            <div className="cp-datarow-row">
                                                                <div className="cp-datarow-label">Account Holder Name</div>
                                                                <div className="cp-datarow-value">{myAutoPayInfo.apiAccountAutoPayACH.holder_name}</div>
                                                            </div>
                                                            <div className="cp-datarow-row">
                                                                <div className="cp-datarow-label">Current Routing #</div>
                                                                <div className="cp-datarow-value">{myAutoPayInfo.apiAccountAutoPayACH.routing_number}</div>
                                                            </div>
                                                            <div className="cp-datarow-row">
                                                                <div className="cp-datarow-label">Current Bank Account #</div>
                                                                <div className="cp-datarow-value">{myAutoPayInfo.apiAccountAutoPayACH.account_number}</div>
                                                            </div>
                                                            <div className="cp-datarow-row">
                                                                <div className="cp-datarow-label">Account Type</div>
                                                                <div className="cp-datarow-value">{myAutoPayInfo.apiAccountAutoPayACH.account_type}</div>
                                                            </div>
                                                        </> }

                                                        {(!autopayUpdated || (myAutoPayInfo && !myAutoPayInfo.apiAccountAutoPayACH)) && <>
                                                        <div className="order-label">New Account</div>

                                                        <div className="form-group">
                                                            <label>Account Holder Name</label>
                                                            <Field
                                                                type="text"
                                                                name="cardHolderName"
                                                                placeholder="Enter holder name"
                                                                value={values.cardHolderName}
                                                                className={"form-control form-control-sm" + (touched.cardHolderName && errors.cardHolderName ? " is-invalid" : "")}
                                                                disabled={myAutoPayInfoLoading && 'disabled'}
                                                            />
                                                            {touched.cardHolderName && errors.cardHolderName &&
                                                                <div className="invalid-feedback">{errors.cardHolderName}</div>
                                                            }
                                                        </div>

                                                        <div className="form-group">
                                                            <label>Routing Number</label>
                                                            <Field
                                                                type="text"
                                                                name="routingNumber"
                                                                placeholder="Enter routing number"
                                                                value={values.routingNumber}
                                                                className={"form-control form-control-sm" + (touched.routingNumber && errors.routingNumber ? " is-invalid" : "")}
                                                                disabled={myAutoPayInfoLoading && 'disabled'}
                                                            />
                                                            {touched.routingNumber && errors.routingNumber &&
                                                                <div className="invalid-feedback">{errors.routingNumber}</div>
                                                            }
                                                        </div>

                                                        <div className="form-group">
                                                            <label>Account Number</label>
                                                            <Field
                                                                type="text"
                                                                name="accountNumber"
                                                                placeholder="Enter account number"
                                                                value={values.accountNumber}
                                                                className={"form-control form-control-sm" + (touched.accountNumber && errors.accountNumber ? " is-invalid" : "")}
                                                                disabled={myAutoPayInfoLoading && 'disabled'}
                                                            />
                                                            {touched.accountNumber && errors.accountNumber &&
                                                                <div className="invalid-feedback">{errors.accountNumber}</div>
                                                            }
                                                        </div>

                                                        <div className="form-group">
                                                            <label>Account Type</label>
                                                            <select
                                                                id="AchAccountType"
                                                                name="accountType"
                                                                onChange={(e) => setFieldValue('accountType', e.target.value)}
                                                                className={"form-control form-control-sm" + (touched.accountType && errors.accountType ? " is-invalid" : "")}
                                                                disabled={myAutoPayInfoLoading && 'disabled'}
                                                            >
                                                                <option value="" selected disabled>Select account type...</option>
                                                                <option value={ACCOUNT_TYPE.CHECKING}>Checking</option>
                                                                <option value={ACCOUNT_TYPE.SAVINGS}>Savings</option>
                                                                <option value={ACCOUNT_TYPE.BUSINESS_CHECK}>Business Check</option>
                                                            </select>
                                                            {touched.accountType && errors.accountType &&
                                                                <div className="invalid-feedback">{errors.accountType}</div>
                                                            }
                                                        </div>
                                                        </> }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {(!autopayUpdated || (myAutoPayInfo && !myAutoPayInfo.apiAccountAutoPayACH)) &&
                                    <div className="form-group text-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={myAutoPayInfoLoading && 'disabled'}
                                        >
                                            Save Changes
                                        </button>
                                    </div>
                                    }

                                </Form>
                            )
                        }}
                    />
                </div>
                }

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const myAutoPayInfo = selectHomeInfo(state).myAutoPayInfo;
    const myAutoPayAvailableCC = selectHomeInfo(state).myAutoPayAvailableCC;

    return {
        myAutoPayInfo,
        myAutoPayAvailableCC
    };
};

const mapDispatchToProps = {
    getMyAutoPayInfo,
    enableAutoPayACH,
    enableAutoPayCC,
    disableAutoPay,
    getAutoPayAvailableCC
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AutoPay);